import type { SVGProps } from 'react'

import { CustomIconProps } from '@/shared/ui/icon-template'

export const DocumentSvg = (props: SVGProps<SVGSVGElement> & CustomIconProps) => {
	return (
		<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M14.0026 5L28.3359 5L28.3359 29C28.3359 32.3137 25.6496 35 22.3359 35L10.0026 35L10.0026 9C10.0026 6.79086 11.7935 5 14.0026 5Z"
				fill="url(#paint0_linear_19781_20862)"
			/>
			<path d="M16.6667 5L30 5L30 31C30 33.2091 28.2091 35 26 35L16.6667 35L16.6667 5Z" fill="#4A4A4A" />
			<path
				d="M25.8351 10C26.2951 10 26.668 10.3729 26.668 10.8329C26.668 11.2928 26.2951 11.6657 25.8351 11.6657L14.1675 11.6657C13.7075 11.6657 13.3346 11.2928 13.3346 10.8329C13.3346 10.3729 13.7075 10 14.1675 10L25.8351 10Z"
				fill="white"
			/>
			<path
				d="M25.8351 15C26.2951 15 26.668 15.3729 26.668 15.8329C26.668 16.2928 26.2951 16.6657 25.8351 16.6657L14.1675 16.6657C13.7075 16.6657 13.3346 16.2928 13.3346 15.8329C13.3346 15.3729 13.7075 15 14.1675 15L25.8351 15Z"
				fill="white"
			/>
			<path
				d="M20.8351 19.998C21.2951 19.998 21.668 20.3709 21.668 20.8309C21.668 21.2909 21.2951 21.6638 20.8351 21.6638L14.1675 21.6638C13.7076 21.6638 13.3347 21.2909 13.3347 20.8309C13.3347 20.3709 13.7076 19.998 14.1675 19.998L20.8351 19.998Z"
				fill="white"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_19781_20862"
					x1="8.33594"
					y1="37.25"
					x2="8.33594"
					y2="5"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#E4EDFC" />
					<stop offset="1" stopColor="#568DFE" />
				</linearGradient>
			</defs>
		</svg>
	)
}
